import React, { useEffect } from 'react'

import cx from 'classnames'
import styles from './FontCard.module.css'
import Card from '../../../components/Card'
import { Font } from '../../../types/Font'

const FontCard: React.FC<{
    font: Font
    onClick: (font: Font) => void
    chosen: boolean
}> = ({ font, onClick, chosen }) => {
    useEffect(() => {
        if (!font.path) return

        const fontFace = new FontFace(font.name, `url(${font.path})`)
        fontFace.load().then((f) => {
            document.fonts.add(f)
        })
    }, [font])

    return (
        <Card
            key={font.id}
            style={{ background: chosen ? '#F1F1F1' : '#FFF' }}
            onClick={() => onClick(font)}
            classes={cx(styles['font-card-wrapper'])}
        >
            <div className={cx(styles['card-inner-wrapper'])}>
                <div
                    title={font.name}
                    className={cx(styles['font-family-wrapper'])}
                    style={{ fontFamily: font.name }}
                >
                    Aa
                </div>
            </div>
        </Card>
    )
}

export default FontCard
